const middleware = {}

middleware['headSite'] = require('..\\middleware\\headSite.js')
middleware['headSite'] = middleware['headSite'].default || middleware['headSite']

export default middleware
